/**
 * Shared PDF types + pure helpers — no pdfjs runtime import, so this module is
 * safe to use from Node (calibration scripts) as well as the browser.
 * The worker-bound loader lives in pdfText.ts.
 */

/** A single positioned text fragment. Coordinates are normalized so that
 *  (x grows right, y grows DOWN) — screen-like. Origin = top-left of the page. */
export interface PdfTextItem {
  str: string;
  x: number;        // left edge, PDF user units
  y: number;        // top-down distance from the top of the page
  width: number;
  height: number;
  fontName?: string;
}

export interface PdfPage {
  pageNumber: number;   // 1-based
  width: number;        // viewport width  (scale 1)
  height: number;       // viewport height (scale 1)
  items: PdfTextItem[];
}

export type PdfInput = File | Blob | ArrayBuffer | Uint8Array | string;

/** Group items into rows by shared y (within `tol` units), each row sorted left→right. */
export function groupIntoRows(items: PdfTextItem[], tol = 3): PdfTextItem[][] {
  const sorted = [...items].sort((a, b) => a.y - b.y || a.x - b.x);
  const rows: PdfTextItem[][] = [];
  for (const item of sorted) {
    const row = rows[rows.length - 1];
    if (row && Math.abs(row[0].y - item.y) <= tol) {
      row.push(item);
    } else {
      rows.push([item]);
    }
  }
  for (const row of rows) row.sort((a, b) => a.x - b.x);
  return rows;
}
